export const emissionErrors = {
	title: "Erreurs d'émission",
	period: "Période",
	export: "Exporter Excel",
	drawer: {
		title: "Historique des erreurs",
		message: "Message",
		type: "Type d'erreur",
		profile: "Profil fiscal",
		count: "Quantité",
		date: "Premier jour non émis",
		updatedAt: "Dernier jour non émis",
		status: "Statut",
		attemptsTitle: "Dernières tentatives d'émission",
		productsTitle: "Produits non émis",
		noAttempts: "Aucune tentative d'émission trouvée",
		noProducts: "Aucun produit non émis trouvé",
		attemptsTable: {
			client: "Client",
			date: "Date",
			error: "Erreur",
		},
		productsTable: {
			product: "Produit",
			count: "Quantité",
		},
	},
	tabs: {
		invoices: "Notes émises",
		products: "Produits non émis",
	},
	table: {
		statusLabel: {
			pending: "En attente",
			resolved: "Résolu",
		},
		errorTypeLabel: {
			unknown: "Inconnu",
		},
		columns: {
			errorMessage: "Message",
			errorType: "Types d'erreur",
			fiscalProfileId: "Profil fiscal",
			count: "Quantité",
			createdAt: "Premier jour non émis",
			updatedAt: "Dernier jour non émis",
			status: "Statut",
		},
	},
};
